import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from 'react-icons/fa';
const About = () => {
  const [isInViewLeft, setIsInViewLeft] = useState(false);
  const [isInViewRight, setIsInViewRight] = useState(false);

  // Refs to target the elements for intersection observer
  const leftElementRef = useRef(null);
  const rightElementRef = useRef(null);

  const iconWrapperStyle = {
    display: 'inline-block',
    width: '40px', /* Size of the circular background */
    height: '40px',
    backgroundColor: 'black',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px', /* Space between the icon and text */
    position: 'relative',
    animation: 'bounce 1s infinite', /* Animation for the bounce effect */
  };

  const playIconStyle = {
    color: 'white',
    fontSize: '20px', /* Size of the play icon */
  };

  // Inline CSS for bounce animation
  const bounceAnimationStyle = {
    '@keyframes bounce': {
      '0%, 100%': {
        transform: 'translateY(0)',
      },
      '50%': {
        transform: 'translateY(-5px)',
      },
    },
  };

  useEffect(() => {
    const options = {
      root: null, // relative to viewport
      rootMargin: "0px",
      threshold: 0.1, // Trigger when 10% of the element is visible
    };

    // Intersection observer callback
    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // If the element is in view, set state to true
          if (entry.target === leftElementRef.current) {
            setIsInViewLeft(true);
          }
          if (entry.target === rightElementRef.current) {
            setIsInViewRight(true);
          }
          observer.unobserve(entry.target); // Stop observing once the element is in view
        }
      });
    };

    // Create the observer
    const observer = new IntersectionObserver(observerCallback, options);

    // Start observing the elements
    if (leftElementRef.current) {
      observer.observe(leftElementRef.current);
    }
    if (rightElementRef.current) {
      observer.observe(rightElementRef.current);
    }

    // Cleanup the observer when the component is unmounted
    return () => {
      if (leftElementRef.current) {
        observer.unobserve(leftElementRef.current);
      }
      if (rightElementRef.current) {
        observer.unobserve(rightElementRef.current);
      }
    };
  }, []);

  return (
    <div>
      <section className="2xl:ud-py-35 pg" style={{paddingTop: '20px', paddingBottom: '40px'}}>
        <div className="bb ze ki xn wq">
          <div className="tc wf gg qq">
            {/* About assets/Images */}
            <div
              ref={leftElementRef}
              className={`xc gn gg jn/2 i ${isInViewLeft ? "slide-left" : ""}`}
            >
              <div>
                {/* <img
                  src="assets/images/shape-05.svg"
                  alt="Shape"
                  className="h -ud-left-5 x"
                /> */}
                <img src="assets/images/Bulk/5.jpg" alt="About" className="ib" />
                <img src="assets/images/Bulk/46.jpg" alt="About" />
              </div>
              <div>
                {/* <img src="assets/images/shape-06.svg" alt="Shape" /> */}
                <img
                  src="assets/images/Bulk/38.jpg"
                  alt="About"
                  className="ob gb"
                />
                <img src="assets/images/Bulk/32.jpg" alt="Shape" className="bb" />
              </div>
            </div>

            {/* About Content */}
            <div
              ref={rightElementRef}
              className={`jn/2 ${isInViewRight ? "slide-right" : ""}`}
            >
              <h4 className="ek yj gb">Why Choose Us</h4>
              <h2 className="fk vj zp pr kk wm qb">
                We Make Our customers happy by giving Best services.
              </h2>
              <p className="uo">
              We are passionate about capturing life's most precious moments with creativity and precision. With years of experience and state-of-the-art equipment, we offer tailored photography services that meet your unique needs. Our commitment to quality, timely delivery and customer satisfaction ensures an exceptional experience every time.
              </p>

              <a
                href="/about"
                data-fslightbox
                className="vc wf hg mb"
              >
              <div style={iconWrapperStyle}>
        <FaPlay style={playIconStyle} />
      </div>
                <span className="kk">SEE HOW WE WORK</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
